import { Skeleton } from 'src/components/atoms'

export const PortfolioNewsDetailSkeleton = (): JSX.Element => (
  <main className="bg-surface-page">
    <div
      className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-6 py-11 md:px-12 xl:px-0"
      role="status"
      aria-label="Loading article…"
      aria-busy="true"
    >
      <Skeleton.Base className="h-4 w-44" />

      <div className="flex flex-col gap-5">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <Skeleton.Base className="h-3.5 w-28 shrink-0" />
          <span
            className="inline-block h-3 w-px shrink-0 bg-border opacity-60"
            aria-hidden
          />
          <Skeleton.Base className="h-3 w-24 shrink-0 opacity-70" />
          <span
            className="inline-block h-3 w-px shrink-0 bg-border opacity-60"
            aria-hidden
          />
          <Skeleton.Base className="h-3 w-20 shrink-0 opacity-70" />
        </div>
        <div className="flex flex-col gap-4">
          <Skeleton.Base className="h-10 w-full max-w-3xl md:h-11" />
          <div
            className="h-px w-full bg-content-secondary opacity-40"
            aria-hidden
          />
        </div>
      </div>

      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-6">
          <Skeleton.Base className="h-8 w-36 rounded-lg" />
          <ul className="flex list-none flex-col gap-3 pl-2">
            <Skeleton.Base className="h-4 w-full" />
            <Skeleton.Base className="h-4 w-[96%]" />
            <Skeleton.Base className="h-4 w-[90%]" />
          </ul>
          <Skeleton.Base className="h-11 w-52 rounded-full" />
        </div>

        <div className="flex flex-col gap-6">
          <Skeleton.Base className="h-7 w-56" />
          <Skeleton.NewsTable rows={4} />
        </div>
      </div>
    </div>
  </main>
)
